import { Component, Host, h, Element, Prop } from '@stencil/core';

const FULL_RADIAL = 350;

export interface AhaRadialProgressLine extends HTMLAhaRadialProgressLineElement {}

/**
 * Custom radial progress component.
 */
@Component({
  tag: 'aha-radial-progress-line',
  styleUrl: 'aha-radial-progress-line.css',
  shadow: true,
})
export class AhaRadialProgressLine {
  @Element() host!: HTMLAhaRadialProgressLineElement;
  /**
   * Color of the `aha-progress-line`.
   */
  @Prop({ reflect: true }) color: string = 'var(--aha-blue-200)';

  /**
   * Radial percentage of the `aha-progress-line`.
   */
  @Prop({ reflect: true }) percent: number = 100;

  render() {
    return (
      <Host>
        <svg xmlns="http://www.w3.org/2000/svg" class="svg" viewBox="0 0 165 138">
          <path
            class="line"
            d="M23 132a77 77 0 1 1 117.93 0"
            fill="none"
            style={{
              strokeDashoffset: `${FULL_RADIAL - Math.min(this.percent / 100, 1) * FULL_RADIAL}`,
              stroke: this.color,
            }}
          />
        </svg>
      </Host>
    );
  }
}
